import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16bef6b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timer" }
const _hoisted_2 = { class: "countdown font-bold" }

import { computed } from 'vue';
import { useGameState } from '@/services/composition';
import { formatCountdown } from '@/services/states/Utils';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const state = useGameState()
const countdown = computed(() => {
  return formatCountdown(state.value.context.countdown)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(countdown)), 1)
  ]))
}
}

})